// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"e21e169c6b32d242954a","303":"9faf80d0eb103e59f745","495":"6aa4dd299e3d33955322"}[chunkId] + ".js";
};